import { BalanceLevel } from 'multirpc-sdk';

import { useAccount } from 'modules/account/hooks/useAccount';
import { useBalance } from 'modules/billing/hooks/useBalance';
import { useChargingModel } from 'modules/billing/hooks/useChargingModel';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

import { fetchAccountStatusFallback } from '../actions/fetchAccountStatus';
import { useAccountStatus } from './useAccountStatus';

export const useIsUserSuspended = () => {
  const { group, isFinance } = useAccount();

  const {
    isFreemium,
    isInactive,
    state: { data },
  } = useAccountStatus();

  const chargingModel = useChargingModel();

  const { data: balanceData, isLoading: balanceLoading } = useBalance();

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();
  const partnerStatusLoading = group && isPartnerStatusLoading;

  const loading = balanceLoading || partnerStatusLoading;

  if (loading) {
    return false;
  }

  const isRegularUserSuspended =
    !isFreemium &&
    isInactive &&
    data !== undefined &&
    data !== fetchAccountStatusFallback;

  const isBalanceTooLow = balanceData?.balance_level === BalanceLevel.TOO_LOW;
  const isDeal = chargingModel?.type === 'deal';
  const isPackage = chargingModel?.type === 'package';

  const hasActiveBundle = isDeal || isPackage;

  const isFinanceSuspended = isBalanceTooLow && !hasActiveBundle;

  const isSuspended = isFinance ? isFinanceSuspended : isRegularUserSuspended;

  return isSuspended && !isPartnerClient;
};
